import React from 'react';
import styles from './TopBar9.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar9 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.zigzagWrapper}>
        
        {/* Segment 1: Phone */}
        <div className={styles.segmentOne}>
          <div className={styles.content}>
            <FaPhoneAlt className={styles.icon} />
            <span>{phone}</span>
          </div>
        </div>

        {/* Segment 2: Email */}
        <div className={styles.segmentTwo}>
          <div className={styles.content}>
            <FaEnvelope className={styles.icon} />
            <span>{email}</span>
          </div>
        </div>

        {/* Segment 3: Social Links */}
        <div className={styles.segmentThree}>
          <div className={styles.socialContent}>
            <a href={facebookUrl} target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>

            <a href={instagramUrl} target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>

            <a href={twitterUrl} target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Segment 4: Brand Accent */}
        <div className={styles.segmentFour}>
          <div className={styles.content}>
            <span className={styles.promoText}>Travel With Us</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar9;